import { Card, CardBox } from '@amboss/design-system';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../hooks/redux';
import useEditProfile from '../../../hooks/useEditProfile';
import useProfile from '../../../hooks/useProfile';
import CardWrapper from '../CardWrapper';
import ProfileCompleted from './ProfileCompleted';
import ProfileEdit from './ProfileEdit';

export const AccountSetup = () => {
  const profileLoaded = useAppSelector((state) => state.profile.profileLoaded);
  const [loading, setLoading] = useState(true);
  const { refreshProfile } = useProfile();
  const { editProfile, closeProfile, openProfile } = useEditProfile();

  useEffect(() => {
    if (profileLoaded) {
      setLoading(false);
    }
  }, [profileLoaded]);

  const handleProfileEditSubmit = () => {
    closeProfile();
    refreshProfile();
  };

  return (
    <CardWrapper>
      <Card>
        <CardBox>
          {!loading && !editProfile ? (
            <ProfileCompleted callback={openProfile} />
          ) : (
            <ProfileEdit callback={handleProfileEditSubmit} />
          )}
        </CardBox>
      </Card>
    </CardWrapper>
  );
};
